import { NzUploadChangeParam } from "ng-zorro-antd/upload";

export function handleUploadChange(e: NzUploadChangeParam) {
    if (e.file.status == "done") {
        e.fileList.filter(f => f.uid == e.file.uid).forEach(f => Object.assign(f, e.file.response));
    }
}